export const MAX_SELF_SERVE_WORKERS = 20;

export function requiresSalesContact(workers: number): boolean {
  return +workers > MAX_SELF_SERVE_WORKERS;
}

export interface PlanSalesContactPayload {
  requested_workers: number | null;
  is_live: boolean;
  account_type: string;
  plan_type?: string;
  current_workers: number;
}
